import CustomReport from '@/services/customReport'
const _cloneDeep = require('lodash/fp/cloneDeep');

function initialState() {
  return {
    reportTemplates: [],
    selectedTemplate: {},
    ranges: [],
    isTemplateLoading: false
  }
}

const state = initialState()

const mutations = {
  SET_TEMPLATE_LOADING(state, status) {
    state.isTemplateLoading = status
  },
  SET_SELECTED_TEMPLATE(state, template) {
    state.selectedTemplate = template
  },
  SET_REPORT_TEMPLATE(state, templates) {
    state.reportTemplates = templates
  },
  RESET_STATE(state) {
    const initial = initialState()
    Object.assign(state, initial)
  }
}

const actions = {
  fetchReportTemplate({ commit }, plantId) {
    CustomReport.fetchReportTemplate(plantId).then(result => {
      commit('SET_REPORT_TEMPLATE', result.data)
    })
  },
  setSelectedTemplate({ commit }, template) {
    commit('SET_SELECTED_TEMPLATE', template)
    commit('SET_RANGE_SELECTION', template.range[0])
  },
  setRangeSelection({ commit }, range) {
    commit('SET_RANGE_SELECTION', range)
  },
  setDateFrom({ commit }, dateFrom) {
    commit('SET_DATE_FROM', dateFrom)
  },
  setDateTo({ commit }, dateTo) {
    commit('SET_DATE_TO', dateTo)
  },
  loadTemplates({commit}, plantId) {
    commit('SET_TEMPLATE_LOADING', true)
    CustomReport.fetchPlantTemplate(plantId)
    .then(response => {
      commit('SET_REPORT_TEMPLATE', response.data.list)
      commit('SET_TEMPLATE_LOADING', false)
    }).catch(err => {
      commit('SET_REPORT_TEMPLATE', [])
      commit('SET_TEMPLATE_LOADING', false)
    })
  },
  resetState({ commit }) {
    commit('RESET_STATE')
  }
}

const getters = {
  getTemplates(state) {
    return state.reportTemplates
  },
  getSelectedTemplate(state) {
    return state.selectedTemplate
  },
  getRanges(state) {
    if(Object.entries(state.selectedTemplate).length > 0) {
      let range = state.selectedTemplate.showCustomDatePicker ? _cloneDeep([...state.selectedTemplate.range, {
        name: 'Custom',
        interval: 'custom'
      }]) : _cloneDeep(state.selectedTemplate.range)
      return range.length > 0 && range[0].constructor === Object ? range.map(el => {
        el['text'] = el['name'];
        delete el['name'];
        return el
      }) : range
    } else {
      return []
    }
  },
  isTemplateLoading(state) {
    return state.isTemplateLoading
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
